import { registerPlugin } from '@capacitor/core';
const Instagram = registerPlugin('Instagram', {
    web: () => import('./web').then(m => new m.InstagramWeb()),
});
export * from './definitions';
export { Instagram };
//# sourceMappingURL=index.js.map